import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/constants/product";

export const Faq = () => (
  <section id="faq" className="mx-auto grid max-w-[1360px] gap-10 px-5 pb-24 sm:px-10 lg:grid-cols-[0.8fr_1.2fr]" data-testid="faq-section">
    <h2 className="font-display text-4xl leading-tight sm:text-5xl">Questions, answered.</h2>
    <Accordion type="single" collapsible className="border-t border-black/15">
      {FAQS.map((f, i) => (
        <AccordionItem key={f.q} value={`f${i}`} className="border-black/15">
          <AccordionTrigger className="font-display text-left text-xl hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
          <AccordionContent className="text-base text-[var(--muted)]">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
